/**
 * PATH: apps/qa/src/components/camera-capture/OnlineIndicator.tsx
 * PURPOSE: Network connectivity status badge
 */

import { Wifi, WifiOff } from 'lucide-react'
import { cn } from '@/lib/utils'

export function OnlineIndicator({ isOnline }: { isOnline: boolean }) {
  return (
    <div className={cn(
      'flex items-center gap-1.5 px-2 py-1 rounded-full text-xs font-medium',
      isOnline ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'
    )}>
      {isOnline ? (
        <>
          <Wifi className="w-3 h-3" />
          Online
        </>
      ) : (
        <>
          <WifiOff className="w-3 h-3" />
          Offline
        </>
      )}
    </div>
  )
}
